import { api } from './api';
import type { Article, CreateArticleInput, UpdateArticleInput } from '../types/entities';

interface PaginatedArticlesResponse {
  data: Article[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const articlesService = {
  /**
   * Get all articles (with pagination)
   */
  async getAll(page = 1, limit = 20): Promise<PaginatedArticlesResponse> {
    const response = await api.get<PaginatedArticlesResponse>('/api/admin/articles', {
      params: { page, limit },
    });
    return response.data;
  },

  /**
   * Get article by ID
   */
  async getById(id: string): Promise<Article> {
    const response = await api.get<Article>(`/api/admin/articles/${id}`);
    return response.data;
  },

  /**
   * Create new article
   */
  async create(data: CreateArticleInput): Promise<Article> {
    const response = await api.post<Article>('/api/admin/articles', data);
    return response.data;
  },

  /**
   * Update existing article
   */
  async update(id: string, data: UpdateArticleInput): Promise<Article> {
    const response = await api.put<Article>(`/api/admin/articles/${id}`, data);
    return response.data;
  },

  /**
   * Publish article
   */
  async publish(id: string): Promise<Article> {
    const response = await api.post<Article>(`/api/admin/articles/${id}/publish`);
    return response.data;
  },

  /**
   * Unpublish article
   */
  async unpublish(id: string): Promise<Article> {
    const response = await api.post<Article>(`/api/admin/articles/${id}/unpublish`);
    return response.data;
  },

  /**
   * Delete article
   */
  async delete(id: string): Promise<void> {
    await api.delete(`/api/admin/articles/${id}`);
  },
};
